import React from "react";

import { ReducedOrderStatusHistory } from "../../generated/graphql";
import {
  orderStatusIconMap,
  orderStatusDisplayNameIdMap,
} from "../../utils/orderStatus";
import { LocalisedText } from "../../i18n";
import { getFormattedTime } from "../../utils/dateString";

import styles from "./style.module.scss";

interface OrderStatusHistoryTimelineProps {
  statusHistories: ReducedOrderStatusHistory[];
}

const OrderStatusHistoryTimeline: React.FC<OrderStatusHistoryTimelineProps> = props => {
  const { statusHistories } = props;

  return (
    <div className={styles.timelineContainer}>
      {/* NOTE: most recent on top */}
      {statusHistories
        .sort((history1, history2) => {
          return history2.when - history1.when;
        })
        .map((history, index) => {
          // NOTE: always show date
          const timeStr = getFormattedTime(new Date(0), new Date(history.when));
          const isLastItem = index === statusHistories.length - 1;
          return (
            <div key={history.when} className={styles.timelineItem}>
              <div className={styles.timelineDot}></div>
              {!isLastItem && <div className={styles.timelineLine}></div>}
              <div className={styles.timelineItemContent}>
                <div className={styles.timelineItemStatus}>
                  <img
                    src={orderStatusIconMap[history.status]}
                    alt="order-status-icon"
                  />
                  <div className={styles.timelineItemStatusText}>
                    <LocalisedText
                      id={orderStatusDisplayNameIdMap[history.status]}
                    />
                  </div>
                </div>
                <div className={styles.timelineItemTimestamp}>{timeStr}</div>
              </div>
            </div>
          );
        })}
    </div>
  );
};

export default OrderStatusHistoryTimeline;
